module.exports = __webpack_public_path__ + "static/media/me-about.080ffe7d.jpg";